import { createApiAction } from 'src/api';

export const FETCH_ACCOUNTS_START = 'account/fetch_accounts_start';
export const FETCH_ACCOUNTS_SUCCESS = 'account/fetch_accounts_success';
export const FETCH_ACCOUNTS_FAILURE = 'account/fetch_accounts_failure';
export const UPDATE_ACCOUNT_STATUS_START =
  'account/update_account_status_start';
export const UPDATE_ACCOUNT_STATUS_SUCCESS =
  'account/update_account_status_success';
export const UPDATE_ACCOUNT_STATUS_FAILURE =
  'account/update_account_status_failure';

export const fetchAccounts = ({ financialInstitutionId, userId }) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/${userId}`,
    },
    [FETCH_ACCOUNTS_START, FETCH_ACCOUNTS_SUCCESS, FETCH_ACCOUNTS_FAILURE]
  );

export const updateAccountStatus = ({
  financialInstitutionId,
  accountId,
  status,
  message,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/`,
      method: 'PATCH',
      body: {
        financial_institution_account_status: status,
        message,
      },
    },
    [
      UPDATE_ACCOUNT_STATUS_START,
      UPDATE_ACCOUNT_STATUS_SUCCESS,
      UPDATE_ACCOUNT_STATUS_FAILURE,
    ]
  );
};

export const fetchAllAccounts = () =>
  createApiAction(
    {
      path: `/api/v1/accounts`,
    },
    [FETCH_ACCOUNTS_START, FETCH_ACCOUNTS_SUCCESS, FETCH_ACCOUNTS_FAILURE]
  );
